import { i18WithParams as t } from '@shared/locale'
import type { Order } from 'components-ui/src/table/table.d'
import { WaitlistInvoiceClientDto, WaitlistOrderClientDto } from 'service-api/src/types/api'
import type { TSearchParams } from './types'

export const allItems = 'all'
export const SERVICE_DATES = 'serviceDates'
export const TIME_ON_WAITLIST = 'timeOn'
export const VISIT_VALUE = 'value'

export const WaitlistSortField = {
  SERVICE_DATES,
  VISIT_VALUE,
  TIME_ON_WAITLIST,
} as const

export interface TWaitlistSort {
  field: TWaitlistSortField
  order: Order
}

export const defaultSearchParams = (): TSearchParams => {
  return {
    service: allItems,
    waitlistStatus: allItems,
    limit: 25,
    nextToken: null,
  }
}

export type TWaitlistSortField = (typeof WaitlistSortField)[keyof typeof WaitlistSortField]

export const disabledST = ['temper-test', 'grooming', 'training']
export const waitListStatusOptions = {
  [allItems]: t('profile.waitlist.status.all'),
  WAITLISTED: t('profile.waitlist.status.waitlisted'),
  CONTACTED: t('profile.waitlist.status.contacted'),
  CONVERTED: t('profile.waitlist.status.converted'),
  REMOVED: t('profile.waitlist.status.removed'),
}
export const waitListStatusKeys = Object.entries(waitListStatusOptions)

export const isWaitlistSortField = (field: string): field is TWaitlistSortField => {
  return Object.values(WaitlistSortField).includes(field as TWaitlistSortField)
}

export const getVisibleWaitList = (waitList: WaitlistOrderClientDto[] = [], sort: TWaitlistSort) => {
  if (waitList.length === 0) return []

  const direction = sort.order === 'asc' ? 1 : -1

  const visible = [...waitList].sort((a, b) => {
    if (sort.field === WaitlistSortField.VISIT_VALUE) {
      return ((a.total ?? 0) - (b.total ?? 0)) * direction
    }

    if (sort.field === WaitlistSortField.TIME_ON_WAITLIST) {
      return (new Date(a.createdAt ?? 0).getTime() - new Date(b.createdAt ?? 0).getTime()) * direction
    }

    return (new Date(a.firstStartDate ?? 0).getTime() - new Date(b.firstStartDate ?? 0).getTime()) * direction
  })

  return visible
}

const getPrimaryOffer = (invoice?: WaitlistInvoiceClientDto, locationServiceTypeId?: string) => {
  return invoice?.items?.find(
    (item) =>
      item.type === 'OFFER' &&
      item.offerType === 'PRIMARY' &&
      (!locationServiceTypeId || item.locationServiceTypeId === locationServiceTypeId)
  )
}

const getPrimaryOfferInvoice = (order: WaitlistOrderClientDto, locationServiceTypeId: string) => {
  if (!locationServiceTypeId) return undefined

  return order.invoices?.find((invoice) => getPrimaryOffer(invoice, locationServiceTypeId))
}

export const getPrimaryOfferDates = (order: WaitlistOrderClientDto, locationServiceTypeId: string) => {
  const invoice = getPrimaryOfferInvoice(order, locationServiceTypeId)
  if (!invoice?.startDate) return undefined

  return {
    startDate: invoice.startDate,
    endDate: invoice.endDate,
  }
}
